// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf9f90fc","455":"82a69af2","977":"f000acc1"}[chunkId] + ".chunk.js";
};